import { create } from 'zustand';

import { GAP_BAN_DAU, luuGap } from './nav-prefs';

export interface ToastSlot {
  msg: string;
  type: 'error' | 'success';
}

export interface ConfirmSlot {
  title: string;
  body: string;
  /**
   * Nhãn nút xác nhận, nhắc lại đúng hành động: `Xoá chứng từ`, `Huỷ nhận dạng`
   * (§10.2). Để trống thì lùi về `Xoá` — hộp xác nhận chỉ dùng cho hành động
   * phá huỷ, nên đó là mặc định an toàn.
   */
  nhanXacNhan?: string;
  /** Nhãn nút thoát. Mặc định `Huỷ` — mọi hộp thoại dùng chung một chữ cho nút thoát. */
  nhanThoat?: string;
  onOk: () => void;
}

interface UiState {
  /** Thanh điều hướng đang gập hay không. Nhớ qua lần tải (ADR-UI-0009). */
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;

  toast: ToastSlot | null;
  /** Chỉ hỗ trợ `success`/`error`; cần `info`/`warning` thì dùng `useToast()`. */
  showToast: (msg: string, type?: ToastSlot['type']) => void;
  hideToast: () => void;

  confirm: ConfirmSlot | null;
  showConfirm: (opts: ConfirmSlot) => void;
  closeConfirm: () => void;
}

/** Kho trạng thái giao diện: toast và hộp xác nhận gọi theo kiểu mệnh lệnh (§9.10). */
export const useUiStore = create<UiState>((set) => ({
  sidebarCollapsed: GAP_BAN_DAU,
  toggleSidebar: () =>
    set((s) => {
      const gap = !s.sidebarCollapsed;
      luuGap(gap);
      return { sidebarCollapsed: gap };
    }),

  toast: null,
  showToast: (msg, type = 'success') => set({ toast: { msg, type } }),
  hideToast: () => set({ toast: null }),

  confirm: null,
  showConfirm: (opts) => set({ confirm: opts }),
  closeConfirm: () => set({ confirm: null }),
}));
